import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DataTypeEnum } from 'src/app/constants/data-type.enum';

@Component({
    selector: 'app-deadline',
    templateUrl: './deadline.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadlineComponent {

  public get DataTypeEnum() {
    return DataTypeEnum;
  }

  @Input() dateSigned!: Date;
  @Input() deadline!: Date;
  @Input() deadlineDays!: any;
}